/**
 *
 * @param {string} project 'mgmt' or 'housekeeper'
 * @param {string} extendUrl 最前面不要加 '/'，ex: 'asset/assetList'
 */
export const getUrl = (project, extendUrl) => {
  project = project.toLowerCase()
  if (project === 'housekeeper') project = 'community'
  const origin = window.location.origin
  if (!origin.includes('kingnetsmart')) return `${origin}/${extendUrl}`
  return `${origin}/${project}/${extendUrl}`
}
